import Alpine from 'alpinejs';

Alpine.data('tabs', () => ({
    isMobile: () => window.matchMedia('(max-width: 64rem)').matches,
    activeTabId: 0,
    headerItems: null,
    tabItems: null,

    init() {
        this.headerItems = this.$root.querySelectorAll('.tabs__item-header');
        this.tabItems = this.$root.querySelectorAll('.tabs-item');
        window.addEventListener('resize', () => this.setAnimatedHeights());
    },
    selectTab(activeTabId, isScrollTo = true) {
        console.info('selectTab', activeTabId, isScrollTo);
        this.headerItems[this.activeTabId].classList.remove('active');
        this.tabItems[this.activeTabId].classList.remove('active');
        this.activeTabId = activeTabId;
        this.headerItems[this.activeTabId].classList.add('active');
        this.tabItems[this.activeTabId].classList.add('active');
        this.setAnimatedHeights();

        if (isScrollTo) {
            setTimeout(() => {
                this.scrollToTabsContent();
            }, 310);
        }
    },
    setAnimatedHeights() {
        const inNeosBackend = window.name === 'neos-content-main';
        if (inNeosBackend) {
            return;
        }
        const headerHeight = this.headerItems[this.activeTabId].querySelector('.tabs__item-header-content').getBoundingClientRect().height;
        this.$root.style.setProperty('--tab-header-height', headerHeight + 'px');
        this.$root.style.setProperty('--tab-header-space-above', headerHeight>0 ? '2.5rem' : '0');
        this.$root.style.setProperty(
            '--tab-height',
            this.tabItems[this.activeTabId].querySelector('.tabs-item__content').getBoundingClientRect().height + 'px'
        );
    },
    scrollToTabsContent() {
        const header = document.querySelector('.header');
        const offset = 20; // top offset is a bit bigger than 0 looks better.
        let headerHeight = 0;
        if (header && !this.isMobile()) {
            headerHeight = header.getBoundingClientRect().top + header.getBoundingClientRect().height;
        }
        const y = this.$root.getBoundingClientRect().top + window.scrollY - headerHeight - offset;

        window.scroll({
            top: y,
            behavior: 'smooth',
        });
    },
}));
